export default __webpack_public_path__ + "static/media/Kaizen.4876b98d.svg";